
import { API_ENDPOINTS } from "@/api/services/changePassword/apiEndpoints";
import { baseApi } from "@/utils/baseApi";

export const changePasswordApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    updatePassword: builder.mutation({
      query: (body) => ({
        url: API_ENDPOINTS.CHANGEPASSWORD.CHANGE_PASSWORD,
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "CHANGEPASSWORD", id: "LIST" }],
    }),
  }),
});

export const { useUpdatePasswordMutation } = changePasswordApi;
